import React from 'react'
import TabsProvider from '../tabs-provider'

const ShowOrder = ({ params: { orderId }, location, children }) => (
  <div>
    <TabsProvider
      pathname={location.pathname}
// @ts-ignore
      location={location}
      tabs={[
        {
          label: 'Manage',
          path: `/ecommerce/orders/${orderId}/manage`
        },
        {
          label: 'Edit Order',
          path: `/ecommerce/orders/${orderId}/edit`
        },
        {
          label: 'Edit Order Items',
          path: `/ecommerce/orders/${orderId}/items`
        },
        {
          label: 'Discounts',
          path: `/ecommerce/orders/${orderId}/discounts`
        }
      ]}
    />
    {children}
  </div>
)

export default ShowOrder
